<template>
	<div class="title">
		<h5><img src="@/assets/imgs/icon68.png" style="margin-right: 10rem;" /><span>{{ title }}</span><img src="@/assets/imgs/icon69.png" style="margin-left: 10rem;" /></h5>
		<span @click="router.push(props.url)">更多 <img src="@/assets/imgs/icon70.png" alt=""></span>
	</div>
</template>
<script setup    >
import { useRouter } from 'vue-router';
const props = defineProps({ 
    title: {
        type: String,
        default: ''
    },
    url: {
        type: String,
        default: ''
    }
})
const router = useRouter()

</script>

<style scoped lang="scss">
.title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding:20rem 15rem;
    h5 {
        display: flex;
        align-items: center;
        color: #333333;
        span{font-size: 16rem;}
        img{
            width: 30rem;
        }
    }
    span {
        cursor: pointer;
        color: #555555;
        font-size: 12rem;
        img{
            width: 16rem;
            margin-left: 5rem;
        }
    }
}
</style>
